import * as React from "react";
import { SVGProps } from "react";
export const ToggleOnIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M6 15C4.61133 15 3.43067 14.514 2.458 13.542C1.486 12.5693 1 11.3887 1 10C1 8.61133 1.486 7.43067 2.458 6.458C3.43067 5.486 4.61133 5 6 5H14C15.3887 5 16.5693 5.486 17.542 6.458C18.514 7.43067 19 8.61133 19 10C19 11.3887 18.514 12.5693 17.542 13.542C16.5693 14.514 15.3887 15 14 15H6ZM6 13.5H14C14.972 13.5 15.7983 13.1597 16.479 12.479C17.1597 11.7983 17.5 10.972 17.5 10C17.5 9.028 17.1597 8.20167 16.479 7.521C15.7983 6.84033 14.972 6.5 14 6.5H6C5.028 6.5 4.20167 6.84033 3.521 7.521C2.84033 8.20167 2.5 9.028 2.5 10C2.5 10.972 2.84033 11.7983 3.521 12.479C4.20167 13.1597 5.028 13.5 6 13.5ZM14 12.5C14.6947 12.5 15.285 12.257 15.771 11.771C16.257 11.285 16.5 10.6947 16.5 10C16.5 9.30533 16.257 8.715 15.771 8.229C15.285 7.743 14.6947 7.5 14 7.5C13.3053 7.5 12.715 7.743 12.229 8.229C11.743 8.715 11.5 9.30533 11.5 10C11.5 10.6947 11.743 11.285 12.229 11.771C12.715 12.257 13.3053 12.5 14 12.5Z"
            fill="currentColor"
        />
    </svg>
);
ToggleOnIcon.displayName = "ToggleOnIcon";
